import * as React from "react";
import UserDetailTopBar from "./Ops.Users.UserDetailTopBar";

import RiskAssessmentContainer from "app/components/AppComponents/Users/Verification/ComplianceScreening/RiskAssessment/RiskAssessmentContainer";
import { RiskAssessmentCreateButtonContainerWithData } from "app/components/AppComponents/Users/Verification/ComplianceScreening/RiskAssessment/RiskAssessmentCreateButtonContainer";
import ManualVerificationContainer from "app/components/AppComponents/Users/Verification/ManualVerification/ManualVerificationContainer";
import { VerificationRequestContainerWithData } from "app/components/AppComponents/Users/Verification/VerificationRequest/VerificationRequestContainer";
import { ComplianceScreeningDataContainerWithData } from "app/components/AppComponents/Users/Verification/ComplianceScreening/ComplianceScreeningDataContainer";
import VerificationSummaryContainer from "app/components/AppComponents/Users/Verification/VerificationSummary/VerificationSummaryContainer";

import IdentityVerificationContainer from "app/components/AppComponents/Users/Verification/IdentityVerification/IdentityVerificationContainer";

import { match } from "react-router-dom";
import { groupAuth } from "app/utils/authGroups";

const hasAccessToVerification = groupAuth.hasAccessGroup(["Ops/Admin"]);
const hasAccessToRiskAssessment = groupAuth.hasAccessGroup([
  "Ops/Admin",
  "Ops/Staff",
]);
const hasAccessToVerificationRequest = groupAuth.hasAccessGroup([
  "Ops/Admin",
  "Ops/Staff",
]);
const hasAccessToVerificationSummary = groupAuth.hasAccessGroup([
  "Ops/Admin",
  "Ops/Staff",
]);

type Props = {
  match: match<{ id: string }>;
  setHeader: (data: { title: string; description: string }) => void;
};

type State = {};

class Verification extends React.Component<Props, State> {
  render() {
    return (
      <React.Fragment>
        <UserDetailTopBar />
        <section className="padded scrollable">
          <div>
            {hasAccessToVerificationSummary && (
              <VerificationSummaryContainer
                external_reference={this.props.match.params.id}
              />
            )}
          </div>
          <div>
            {hasAccessToVerificationRequest && (
              <VerificationRequestContainerWithData
                external_reference={this.props.match.params.id}
              />
            )}
          </div>

          <div>
            {hasAccessToRiskAssessment && (
              <IdentityVerificationContainer
                external_reference={this.props.match.params.id}
              />
            )}
          </div>

          <div>
            {hasAccessToRiskAssessment && (
              <RiskAssessmentContainer
                external_reference={this.props.match.params.id}
              />
            )}
          </div>

          <div>
            {hasAccessToRiskAssessment && (
              <RiskAssessmentCreateButtonContainerWithData
                external_reference={this.props.match.params.id}
                onUserChanged={(user) => {}}
              />
            )}
          </div>

          <div>
            {hasAccessToRiskAssessment && (
              <ComplianceScreeningDataContainerWithData
                external_reference={this.props.match.params.id}
                onUserChanged={(user) => {}}
              />
            )}
          </div>

          <div>
            {hasAccessToVerification && (
              <ManualVerificationContainer
                external_reference={this.props.match.params.id}
                onUserChanged={(user) => {}}
              />
            )}
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Verification;
